import axios from 'axios'
import { ContactDepartment } from '@/types/contact'

export default async function updateContactDepartments(payload: {
  items: Pick<ContactDepartment, 'id' | 'sort'>[]
}) {
  await axios.put('/api/v1/contacts-department/mass', payload)
}
